
import { useEffect } from 'react';
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import ConsultationHero from './components/ConsultationHero';
import ConsultationServices from './components/ConsultationServices';
import ConsultationBooking from './components/ConsultationBooking';
import ConsultationFAQ from './components/ConsultationFAQ';

export default function Consultation() {
  useEffect(() => {
    // Add Schema.org JSON-LD for consultation page
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "OED Tiny Homes Consultation Services",
      "description": "Professional consultation services for glamping retreat investments, property development, and business planning.",
      "url": `${import.meta.env.VITE_SITE_URL || "https://example.com"}/consultation`,
      "provider": {
        "@type": "Organization",
        "name": "OED Tiny Homes and Glamping Retreat Developments"
      },
      "offers": [
        {
          "@type": "Offer",
          "name": "Investment Strategy Consultation",
          "price": "150",
          "priceCurrency": "USD"
        },
        {
          "@type": "Offer", 
          "name": "Property Development Consultation",
          "price": "200",
          "priceCurrency": "USD"
        },
        {
          "@type": "Offer",
          "name": "Business Planning Session", 
          "price": "175",
          "priceCurrency": "USD"
        },
        {
          "@type": "Offer",
          "name": "Market Analysis Review",
          "price": "125", 
          "priceCurrency": "USD"
        }
      ]
    });
    document.head.appendChild(script);

    // Update page title and meta
    document.title = "Professional Consultation Services | OED Tiny Homes Glamping Experts";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Book professional consultation services with OED Tiny Homes experts. Investment strategy, property development, business planning, and market analysis for glamping retreats.');
    }

    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(s => s.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <main>
        <ConsultationHero />
        <ConsultationServices />
        <ConsultationBooking />
        <ConsultationFAQ />
      </main>
      <Footer />
    </div>
  );
}
